<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="bg-white pd-15">
      <!-- 账户信息 -->
      <div class="accountInfo slice">
        <div class="color409eff fw-600 mgb-15">账户信息</div>
        <el-form ref="accountForm" :model="accountForm" label-width="100px">
          <el-form-item label="剩余短信条数">
            <el-input :disabled="true" v-model="accountForm.msg"></el-input>
          </el-form-item>
          <el-form-item label="剩余语音条数">
            <el-input :disabled="true" v-model="accountForm.call"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 预警时间与预警联系人 -->
      <div class="timeOrPhone slice pdb-15">
        <div class="color409eff fw-600 mgb-15 mgt-15">预警时间</div>
        <el-form
          ref="timeOrPhoneForm"
          :model="timeOrPhoneForm"
          label-width="135px"
          :rules="rules"
        >
          <el-form-item label="系统每日沟通时间" prop="time">
            <el-time-picker
              is-range
              arrow-control
              v-model="timeOrPhoneForm.time"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm"
              value-format="HH:mm"
            >
            </el-time-picker>
          </el-form-item>
          <div class="color409eff fw-600 mgb-15 mgt-15">预警联系人</div>
          <div class="flex" v-for="(v, i) in timeOrPhoneForm.phones" :key="i">
            <el-form-item
              :label="'联系电话' + (i + 1)"
              :prop="`phones.${i}.phone`"
              :rules="rules.phone"
            >
              <el-input
                v-model="v.phone"
                placeholder="请输入联系人电话"
                clearable
              ></el-input>
            </el-form-item>
            <i
              v-if="i !== 0"
              @click.prevent="removePhone(v)"
              class="delIcon el-icon-delete"
            ></i>
          </div>
          <el-button
            v-if="timeOrPhoneForm.phones.length < 3"
            @click="addPhone"
            type="success"
            >新增联系电话</el-button
          >
          <el-button type="primary" @click="saveTimeOrPhones('timeOrPhoneForm')"
            >保 存</el-button
          >
        </el-form>
      </div>

      <!-- 预警类型 -->
      <div class="slice pdb-15">
        <div class="color409eff fw-600 mgb-15 mgt-15">预警类型</div>
        <div class="flex aic jcsa">
          <div class="earlyType" v-for="v in typeArr" :key="v.id">
            <div
              class="title fw-600 color4272ea"
              v-text="
                v.warnType == 1
                  ? '设备离线预警'
                  : v.warnType == 2
                  ? '租赁设备临期预警'
                  : '设备滤芯余量预警'
              "
            ></div>
            <div v-if="v.warnType == 1" class="hint f12 mgt-5">
              设备离线且超过十分钟未上线通知一次
            </div>
            <div v-if="v.warnType == 2" class="hint f12 mgt-5">
              设备租期剩余20天时通知一次
            </div>
            <div class="hint f12 mgt-5" v-if="v.warnType == 3">
              <div>计时滤芯将在倒计时30天时通知一次</div>
              <div>计时滤芯将在滤芯使用达90%时通知一次</div>
            </div>
            <!-- 短信 -->
            <div class="mgt-15 flex aic jcsb">
              <div>
                <div class="fw-600">短信预警服务</div>
                <div class="f12">
                  单日同类型预警存在多台设备，仅短信预警一次
                </div>
              </div>
              <el-switch
                v-model="v.msgOpen"
                active-color="#5a7bf4"
                inactive-color="#ccc"
                @change="msgOpen(v)"
              >
              </el-switch>
            </div>
            <!-- 语音 -->
            <div class="mgt-15 flex aic jcsb">
              <div>
                <div class="fw-600">语音电话预警服务</div>
                <div class="f12">
                  单日同类型预警存在多台设备，仅语音预警一次
                </div>
              </div>
              <el-switch
                :transition="false"
                v-model="v.callOpen"
                active-color="#5a7bf4"
                inactive-color="#ccc"
                @change="callOpen(v)"
              >
              </el-switch>
            </div>
            <!-- footer -->
            <div class="flex jcsb aic mgt-15">
              <div class="fw-600">关闭预警设备名单</div>
              <div class="detail" @click="goDetail(v)">详情</div>
            </div>
          </div>
        </div>
      </div>
      <!-- ========= -->
      <!-- 套餐 -->
      <!-- 短信 -->
      <div class="color409eff fw-600 mgb-15 mgt-15">短信充值套餐</div>
      <div class="flex aic fww">
        <div v-if="msgMenuArr.length < 1">暂无套餐</div>
        <div class="set" v-for="v in msgMenuArr" :key="v.id" @click="goPay(v)">
          <div class="one">
            {{ v.num }}条（{{
              v.validityMoth ? v.validityMoth + "个月" : "永久有效"
            }}）
          </div>
          <div class="two">
            <div>{{ v.payPrice }}元</div>
            <div>{{ v.unitPrice }}元/条</div>
          </div>
        </div>
      </div>
      <!-- == -->
      <!-- 语音 -->
      <div class="color409eff fw-600 mgb-15 mgt-15">语音电话套餐充值</div>
      <div class="flex aic fww">
        <div v-if="callMenuArr.length < 1">暂无套餐</div>
        <div class="set" v-for="v in callMenuArr" :key="v.id" @click="goPay(v)">
          <div class="one">
            {{ v.num }}条 （{{
              v.validityMoth ? v.validityMoth + "个月" : "永久有效"
            }}）
          </div>
          <div class="two">
            <div>{{ v.payPrice }}元</div>
            <div>{{ v.unitPrice }}元/条</div>
          </div>
        </div>
      </div>
      <!-- = -->
    </div>
  </div>
</template>

<script>
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    // 新增联系方式验证
    const addPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请填写联系方式"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      accountForm: {
        msg: "0",
        call: "0",
      }, //账户信息表单
      timeOrPhoneForm: {
        time: ["08:40", "09:40"],
        phones: [{ phone: "" }],
      }, //预警时间和电话
      rules: {
        time: [{ required: true, message: "请选择预警时间", trigger: "blur" }],
        phone: [{ required: true, validator: addPhone, trigger: "blur" }],
      },
      msgValue: false,
      callValue: false,
      typeArr: [], //预警类型数组
      msgMenuArr: [],
      callMenuArr: [],
    };
  },

  created() {
    this.getDetail();
    this.getMsgSetList();
    this.getCallSetList();
  },
  methods: {
    // 整个页面的详情
    getDetail() {
      this.$api.communication.earlyDetail().then((res) => {
        if (res.code === 200) {
          this.accountForm.msg = res.data.warnNum.msgNumNow;
          this.accountForm.call = res.data.warnNum.callNumNow;
          if (
            res.data.setting.phoneStartTime &&
            res.data.setting.phoneStartTime
          ) {
            const timeData = [
              res.data.setting.phoneStartTime,
              res.data.setting.phoneEndTime,
            ];
            this.timeOrPhoneForm.time = timeData.map((timeStr) =>
              timeStr.substring(0, 5)
            );
          }

          if (res.data.setting.phones) {
            let phone = res.data.setting.phones.split(",");
            this.timeOrPhoneForm.phones = [];
            phone.forEach((v) => {
              this.timeOrPhoneForm.phones.push({
                phone: v,
              });
            });
          }

          this.typeArr = res.data.opens;
          //
        }
      });
    },

    // 套餐列表
    getMsgSetList() {
      this.$api.communication.setList({ packageType: 1 }).then((res) => {
        if (res.code === 200) {
          this.msgMenuArr = res.data;
        }
      });
    },

    getCallSetList() {
      this.$api.communication.setList({ packageType: 2 }).then((res) => {
        if (res.code === 200) {
          this.callMenuArr = res.data;
        }
      });
    },

    // 预警时间和预警联系人保存
    saveTimeOrPhones(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("是否保存通知时间和联系电话？", "info")
            .then(() => {
              let phones = [];
              this.timeOrPhoneForm.phones.forEach((v) => {
                phones.push(v.phone);
              });
              this.$api.communication
                .infoEdit({
                  phoneStartTime: this.timeOrPhoneForm.time[0] + ":00",
                  phoneEndTime: this.timeOrPhoneForm.time[1] + ":00",
                  phones: phones,
                })
                .then((d) => {
                  if (d.code === 200) {
                    handleAlert("信息保存成功", "success");
                    this.getDetail();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 查看关闭预警设备列表页面详情
    goDetail(v) {
      this.$router.push({
        path: "/communication/communicationSet/closeEarly",
        query: {
          data: v,
        },
      });
    },

    // 新增联系电话
    addPhone() {
      this.timeOrPhoneForm.phones.push({
        phone: "",
      });
    },
    // 删除联系电话
    removePhone(v) {
      if (this.timeOrPhoneForm.phones.length == 1) {
        handleAlert("联系电话必须保留一个", "error");
        return;
      }
      var index = this.timeOrPhoneForm.phones.indexOf(v);
      if (index !== -1) {
        this.timeOrPhoneForm.phones.splice(index, 1);
      }
    },

    // 开关
    msgOpen(v) {
      if (this.timeOrPhoneForm.phones[0].phone == "") {
        handleAlert("请先添加预警联系人电话", "error");
        v.msgOpen = false;
        return;
      }
      if (this.accountForm.msg == 0 || !this.accountForm.msg) {
        handleAlert("短信条数不足，请充值", "error");
        v.msgOpen = false;
        return;
      }
      if (v.msgOpen === false) {
        v.msgOpen = true;
        handleConfirm("关闭后将无法接收短信预警，确认关闭吗", "info")
          .then(() => {
            this.$api.communication
              .open({ id: v.id, open: false, openType: 1 })
              .then((res) => {
                if (res.code === 200) {
                  v.msgOpen = false;
                  handleAlert("设置成功", "success");
                  this.getDetail();
                }
              });
          })
          .catch(() => {
            return;
          });
      } else {
        this.$api.communication
          .open({ id: v.id, open: true, openType: 1 })
          .then((res) => {
            if (res.code === 200) {
              v.msgOpen = true;
              handleAlert("设置成功", "success");
              this.getDetail();
            }
          });
      }
    },

    callOpen(v) {
      if (this.timeOrPhoneForm.phones[0].phone == "") {
        handleAlert("请先添加预警联系人电话", "error");
        v.callOpen = false;
        return;
      }

      if (this.accountForm.call == 0 || !this.accountForm.call) {
        handleAlert("语音条数不足，请充值", "error");
        v.callOpen = false;
        return;
      }

      if (v.callOpen === false) {
        v.callOpen = true;
        handleConfirm("关闭后将无法接收语音预警，确认关闭吗", "info")
          .then(() => {
            this.$api.communication
              .open({ id: v.id, open: false, openType: 2 })
              .then((res) => {
                if (res.code === 200) {
                  v.callOpen = false;
                  handleAlert("设置成功", "success");
                  this.getDetail();
                }
              });
          })
          .catch(() => {
            return;
          });
      } else {
        this.$api.communication
          .open({ id: v.id, open: true, openType: 2 })
          .then((res) => {
            if (res.code === 200) {
              v.callOpen = true;
              handleAlert("设置成功", "success");
              this.getDetail();
            }
          });
      }
    },
    goPay(v) {
      this.$router.push({
        path: "/communication/communicationSet/pay",
        query: {
          data: v,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.accountInfo .el-input {
  width: 200px;
}
.timeOrPhone .el-input {
  width: 200px;
}
.delIcon {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-left: 10px;
}
.earlyType {
  width: 25%;
  height: 210px;
  background-color: #ececec;
  border-radius: 15px;
  box-sizing: border-box;
  padding: 10px 20px 10px 15px;
}
.detail {
  cursor: pointer;
  text-decoration: underline;
  color: #5a7bf4;
}
.set:hover {
  border: 1px solid #5a7bf4;
  color: #5a7bf4;
}
.set {
  width: 150px;
  height: 70px;
  border: 1px solid var(--input-border);
  box-sizing: border-box;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 10px;
  .one {
    height: 35px;
    text-align: center;
    line-height: 35px;
    border-bottom: 1px solid var(--input-border);
    font-size: 12px;
  }
  .two {
    display: flex;
    align-items: center;
    justify-content: space-around;
    line-height: 35px;
    font-size: 12px;
  }
}
</style>
